/**
 * Created by senani on 1/2/19.
 */

import React, {Component} from "react";
import "./AllOrderBottom.css";
import Pagination from "react-js-pagination";

class AllOrderBottom extends Component{
    constructor(props) {
        super(props);
    }

    render(){

        return(
            <div className="row">
                <div className="table-area__pagination">
                    <Pagination
                        activePage={this.props.activePage}
                        itemsCountPerPage={this.props.itemsCountPerPage}
                        totalItemsCount={this.props.totalItemsCount}
                        pageRangeDisplayed={5}
                        onChange={this.props.handlePageChange}
                    />
                </div>
            </div>

        )
    }
}

export default AllOrderBottom;


// WEBPACK FOOTER //
// ./src/components/Admin/Order/ViewAllOrders/AllOrderBottom/AllOrderBottom.js